/** Available reminder types */
export enum ReminderTypeEnum {
  /** Project personal reminder */
  PROJECT = 'PROJECT',
  /** Project checklist reminder for checklist responsible */
  PROJECT_CHECKLIST = 'PROJECT_CHECKLIST',
  /** Deal personal reminder */
  DEAL = 'DEAL',
  /** Deal event reminder for event responsible */
  DEAL_EVENT = 'DEAL_EVENT',
  /** HelpDesk task reminder */
  HELPDESK = 'HELPDESK',
}
